export default {
  title: {
    en: 'Do you want an extra life?',
    fr: 'Voulez-vous une nouvelle vie?',
    it: 'Vuoi una vita in più?',
    nl: 'Wil je een extra leven?'
  },

  description: {
    en: (price: number) =>
      `Buy an extra life for ${price} My McDonald's bonus points.`,

    fr: (price: number) =>
      `Achetez une vie supplémentaire pour ${price} points bonus My McDonald's.`,

    it: (price: number) =>
      `Acquista una vita extra per ${price} punti bonus My McDonald's.`,

    nl: (price: number) =>
      `Koop een extra leven voor ${price} My McDonald's bonuspunten.`
  },

  balance: {
    en: 'Your balance:',
    fr: 'Votre solde:',
    it: 'Il tuo bilancio:',
    nl: 'Je balans:'
  },

  submit: {
    en: 'Buy extra life',
    fr: 'Acheter une vie',
    it: 'Compra vita extra',
    nl: 'Koop een extra leven'
  },

  cancel: {
    // eslint-disable-next-line quotes
    en: "No, I'll quit",
    fr: 'Non, je vais arrêter',
    it: 'No, smetto',
    nl: 'Nee, ik stop ermee'
  }
};
